import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { PACKAGES, gbp, fmtDate } from "@/lib/constants";
import SecurityPanel from "@/components/SecurityPanel";
import { StatusBadge } from "@/components/ui/bits";
import { Receipt, BarChart3, CalendarClock, ChevronRight } from "lucide-react";

export default function ClientAccount() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [deadlines, setDeadlines] = useState([]);

  useEffect(() => {
    api.get("/clients").then(({ data }) => setClient(data.filter(Boolean)[0] || null)).catch(() => {});
    api.get("/deadlines").then(({ data }) => setDeadlines(data)).catch(() => {});
  }, []);

  const pkg = client ? PACKAGES[client.package] : null;
  const upcoming = deadlines.filter((d) => d.status !== "completed");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif font-bold text-3xl text-white mb-1">Account</h1>
        <p className="text-slate-400">{user.name} · {user.email}</p>
      </div>

      {pkg && (
        <div className="card-surface rounded-2xl p-5">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#C9A84A]">Your package</span>
          <div className="flex items-center justify-between mt-1">
            <h2 className="font-serif font-bold text-white text-2xl">{pkg.name}</h2>
            <span className="gold-text font-serif font-bold">{client.fee ? `${gbp(client.fee)}/mo` : "Custom"}</span>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">
        <button onClick={() => navigate("/reports")} className="card-surface rounded-2xl p-4 text-left hover:bg-[#18243F] transition-colors flex items-center justify-between" data-testid="account-reports">
          <div className="flex items-center gap-3"><BarChart3 className="text-[#C9A84A]" size={20} /><span className="text-white">Reports</span></div><ChevronRight size={18} className="text-slate-600" />
        </button>
        <button onClick={() => navigate("/invoices")} className="card-surface rounded-2xl p-4 text-left hover:bg-[#18243F] transition-colors flex items-center justify-between" data-testid="account-invoices">
          <div className="flex items-center gap-3"><Receipt className="text-[#C9A84A]" size={20} /><span className="text-white">Invoices</span></div><ChevronRight size={18} className="text-slate-600" />
        </button>
      </div>

      <div>
        <h2 className="font-serif font-bold text-xl text-white mb-3 flex items-center gap-2"><CalendarClock size={20} className="text-[#C9A84A]" /> Your deadlines</h2>
        {upcoming.length === 0 ? <p className="text-slate-500 text-sm card-surface rounded-xl p-4">Nothing due right now.</p> : (
          <div className="space-y-2">
            {upcoming.slice(0, 8).map((d) => (
              <div key={d.id} className="card-surface rounded-xl p-3 flex items-center justify-between">
                <div><div className="text-white text-sm">{d.title}</div><div className="text-slate-500 text-xs">Due {fmtDate(d.due_date)}</div></div>
                <StatusBadge status={d.status} overdue={d.is_overdue} />
              </div>
            ))}
          </div>
        )}
      </div>

      <div>
        <h2 className="font-serif font-bold text-xl text-white mb-3">Security</h2>
        <SecurityPanel />
      </div>
    </div>
  );
}
